import { useLayoutEffect as u, useEffect as E } from "react";
function d(n, o) {
  window.dispatchEvent(new CustomEvent(n, { detail: o }));
}
const f = typeof window < "u" ? u : E;
function w(n) {
  function o(r) {
    const e = Object.keys(r).reduce((t, s) => (t[`${n}:${s}`] = (i) => r[s](i.detail), t), {});
    f(() => (Object.keys(e).forEach((t) => {
      window.removeEventListener(t, e[t]), window.addEventListener(t, e[t]);
    }), () => Object.keys(e).forEach((t) => {
      window.removeEventListener(t, e[t]);
    })), [e]);
  }
  function c(r) {
    return (...e) => d(`${n}:${String(r)}`, e[0]);
  }
  return [o, c];
}
export {
  w as createUseExternalEvents
};
